module.exports = __webpack_public_path__ + "static/image/logo-family/logo_robot@2x.png?98e526c6";